import { GIT_SHA, IS_DEV } from '../viteEnv';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import ENV from '../env.json';
import '../index.css';
import { initSentry } from '../sentry';
import { start } from '../stackdriverErrorReporter';
import './00_init';
import './01_i18n';
import { StandaloneApp } from './StandaloneApp';

// Vite code-splits lazy components into content-hashed chunks; a deploy removes
// the old hashes. A user on a stale tab who navigates to a lazy route then 404s
// on the (now-deleted) chunk → 'vite:preloadError'. Reload once to pick up the
// fresh index.html + current chunk names. The sessionStorage guard prevents a
// reload loop if a chunk is genuinely broken (bad deploy). new-main.
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('chunkReloaded')) return;
  sessionStorage.setItem('chunkReloaded', '1');
  window.location.reload();
});

initSentry(ENV.sentry?.standaloneDsn || undefined);

start({
  key: ENV.errorReporting.apiKey,
  projectId: ENV.errorReporting.projectId,
  service: 'standalone-app',
  version: GIT_SHA,
  disabled: IS_DEV
});

ReactDOM.render(
  <Suspense fallback={null}>
    <StandaloneApp />
  </Suspense>,
  document.getElementById('root')
);
